'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageConstants = exports.PageConstants = (0, _keymirror2.default)({
    SET_PAGE_LIST: null,

    PAGE_DETAIL_LOAD_REQUEST: null,
    PAGE_DETAIL_LOAD_SUCCES: null,
    PAGE_DETAIL_LOAD_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/page.js
// module id = 1874
// module chunks = 0